import { IGroupUpdateAction } from './types';
import { TChatGroupAction } from '../../chatGroup/actions/types';
import { AT_GROUP_UPDATE } from './constants';
import { TChatGroupId } from '../../../../../../../types/rest/IRestChatGroup';

export const chatGroupUpdateAction = (
    id: TChatGroupId,
    action: TChatGroupAction,
): IGroupUpdateAction => ({
    type: AT_GROUP_UPDATE,
    id,
    action,
});
